import * as _message from 'element-ui';

export const messageBox = {
  msgBox(obj) {
    let init = this.mergeAssign(obj);
    return _message.MessageBox[init.defaultType](init.message, init.title, {
      ...init.param
    });
  },
  // prompt(obj) {
  //   let init = this.mergeAssign(obj);
  //   return _message.MessageBox[init.defaultType](init.message, init.title, {
  //     ...init.param
  //   });
  // },
  mergeAssign(obj) {
    let init = this.initialize();
    Object.assign(init, obj);
    return init;
  },
  initialize() {
    const obj = {
      defaultType: 'confirm', // 默认confirm 其次还有 alert
      title: '消息', // 提示标题
      message: '请慎重此操作, 是否继续?', // 提示消息
      param: {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      },
      successMsg: '成功',
      infoMsg: '取消'
    };
    return obj;
  }
};

export default messageBox;
